import {NumberFilterModel} from 'ag-grid-community';
import {FilterModel} from '../../../filter-model';
import {ISimpleFilterModelType} from 'ag-grid-community';

export function isNumberFilter(
  filterMode: FilterModel<ISimpleFilterModelType>,
): filterMode is NumberFilterModel {
  return filterMode.filterType === 'number';
}
